/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2017, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

import {
  SvgIcon,
  Heading,
  Button
} from "../"

export class FileSelector extends React.Component {
  static propTypes = {
    label: PropTypes.string,
    buttonLabel: PropTypes.string,
    dropzone: PropTypes.bool,
    integrated: PropTypes.bool,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    cancelButton: PropTypes.bool,
    onCancel: PropTypes.func,
    reset: PropTypes.bool,
    accept: PropTypes.string,  // accepted file format, like 'image/png'
    onSelected: PropTypes.func,
    className: PropTypes.string
  }

  constructor(props) {
    super(props)

    this.state = {
      dragInZone: false,
      files: null,
      filesDropped: false
    }
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.reset) {
      this.setState({
        dragInZone: false,
        files: null,
        filesDropped: false
      })
    }
  }

  componentDidMount(props) {
    if (document.getElementById("outer")) {
      this.setState({
        parentWidth: document.getElementById("outer").parentNode.offsetWidth,
        parentHeight: document.getElementById("outer").parentNode.offsetHeight - 40
      })
    }
  }

  // add code to prevent default browser behaviour if file dropped outside drop zone

  render() {
    if (this.props.integrated) {
      // use 'integrated' when an entire container should be droppable. The container should have a visible boundary
      return (
        <div className={this.props.className}>
          <div
            className="slds-box"
            style={{ minHeight: 300, backgroundColor: "white" }}>
            <div
              id="outer"
              className="slds-size_1-of-1"
              onDragOver={(e) => {
                e.preventDefault()  // necessary - allows us to drop
              }}
              onDragEnter={(e) => {
                this.setState({ dragInZone: true })
              }}
              onDragLeave={(e) => {
                this.setState({
                  dragInZone: false
                })
              }}
              onDrop={(e) => {
                e.stopPropagation() // stops the browser from redirecting by default
                e.preventDefault()

                this.setState({
                  files: e.dataTransfer.files,
                  filesDropped: true
                })
              }}>
              {this.state.filesDropped
                ? <div
                    className="slds-align_absolute-center"
                    style={{
                      width: this.state.parentWidth - 40,
                      height: this.state.parentHeight
                    }}>
                    <Heading>
                      Number of files selected:
                      <div className="slds-align_absolute-center">
                        {Object.keys(this.state.files).length}
                      </div>
                    </Heading>
                  </div>
                : <div className="slds-form-element">
                    <div className="slds-form-element__control">
                      <div className="slds-file-selector slds-file-selector_integrated" aria-hidden={true}>
                        <div className="slds-file-selector__dropzone slds-file-selector__dropzone_integrated slds-has-drag">
                          <input
                            type="file"
                            className="slds-file-selector__input slds-assistive-text"
                            accept={this.props.accept}
                            id="file-upload-input-01"
                            tabIndex={-1}
                            multiple
                            onChange={e => {
                              this.setState({
                                files: e.target.files,
                                filesDropped: true
                              })
                            }}
                          />
                          <label
                            className="slds-file-selector__body slds-file-selector__body_integrated file-selector"
                            htmlFor="file-upload-input-01"
                            style={{
                              width: this.state.parentWidth,
                              height: this.state.parentHeight
                            }}>
                            <SvgIcon
                              variant="utility"
                              symbol="upload"
                              className="slds-file-selector__body-icon slds-icon slds-icon-text-default"
                            />
                            {this.props.dropzone &&
                              <span className="slds-file-selector__text slds-file-selector__text_integrated slds-text-heading_medium slds-text-align_center">
                                Click to select or drop file(s) here
                              </span>
                            }
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                }
            </div>
          </div>
          <div className="slds-clearfix slds-m-top_medium">
            <div className="slds-float_right">
              {this.props.cancelButton &&
                <Button
                  className="u-text-caps slds-m-right_x-small"
                  onClick={this.props.onCancel}
                  minWidth={150}>
                  Cancel
                </Button>
              }
              <Button
                type="brand"
                className="u-text-caps"
                disabled={this.props.disabled || !this.state.files}
                onClick={() => this.props.onClick(this.state.files)}
                minWidth={150}>
                {this.props.buttonLabel || "Upload"}
              </Button>
            </div>
          </div>
        </div>
      )
    } else {
      return (
        <div className={`slds-form-element ${this.props.className ? this.props.className : ''}`}>
          {this.props.label &&
            <span className="slds-form-element__label" id="file-selector-primary-label">
              {this.props.label}
            </span>
          }
          <div className="slds-form-element__control">
            <div className="slds-file-selector slds-file-selector_files">
              <div className="slds-file-selector__dropzone">
                <input
                  type="file"
                  className="slds-file-selector__input slds-assistive-text"
                  accept={this.props.accept}
                  id="file-upload-input-01"
                  onChange={this.props.onSelected}
                  aria-labelledby="file-selector-primary-label file-selector-secondary-label"
                  multiple
                />
                <label className="slds-file-selector__body" htmlFor="file-upload-input-01" id="file-selector-secondary-label">
                  <span className="slds-file-selector__button slds-button slds-button_neutral">
                    <SvgIcon
                      variant="utility"
                      symbol="upload"
                      buttonIcon={true}
                      className="slds-p-right_small"
                    />
                    {this.props.buttonLabel || "Upload files"}
                  </span>
                  {this.props.dropzone &&
                    <span className="slds-file-selector__text slds-medium-show">
                      or Drop files
                    </span>
                  }
                </label>
              </div>
            </div>
          </div>
        </div>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/file-selector/index.js